<template>
  <div class="pb-8">
    <span v-if="userData">
<v-alert type="success">
  <h2 class="text-white">Sie sind jetzt eingeloggt.</h2>
</v-alert>
    </span>
    <span v-if="!userData">
    <v-row v-if="showClose"
          ><v-col cols="10"></v-col
          ><v-col cols="2"
            ><v-btn icon @click="userStore.closeLogin">
              <v-icon>mdi-close</v-icon>
            </v-btn></v-col
          ></v-row
        >
        <div v-if="!showPassVergessen">
          <h2 class="mb-4 clearment-title">{{ t('loginView.title', { brand: brandName }) }}</h2>
          <p class="clearment-subtitle">{{ t('loginView.subtitle') }}</p>
          <p class="mb-4">
            {{ t('loginView.noAccount.text') }}
            <router-link @click="userStore.setLoginView(false)" to="/register" class="clearment-link">
              {{ t('loginView.noAccount.link') }}
            </router-link>
          </p>

          <div class="token-login-card mb-6">
            <div class="card-header">
              <h3 class="token-login-title">{{ t('loginView.token.title') }}</h3>
              <p class="token-login-text">
                {{ t('loginView.token.description') }}
              </p>
            </div>
            <v-form @submit.prevent="startTokenLoginFromForm" class="card-form">
              <v-text-field
                v-model="tokenLogin.token"
                :label="t('loginView.token.tokenLabel')"
                variant="outlined"
                density="comfortable"
                :error-messages="tokenLoginErrors.token"
                class="mb-4"
              />
              <v-btn
                block
                color="#EA5545"
                variant="flat"
                type="submit"
              >
                {{ t('loginView.token.button') }}
              </v-btn>
            </v-form>
          </div>

          <span v-if="showSocialLogin">
  <v-row  v-if="!isLoggedIn" class="mt-2">
        <v-col cols="12" md="6">
          <v-btn
    color="#DB4437" 
    @click="loginWithGoogle"
    class="text-center white--text"
    block
    justify="center"
  >
    <v-icon class="mr-2">mdi-google</v-icon>
    Mit Google anmelden
  </v-btn>
  
        </v-col>
 
        <v-col cols="12" md="6" v-if="showFacebookLogin">
          <v-btn
            color="primary"
            @click="loginWithFacebook"
           
            block
            variant="elevated"
          >
            <template v-slot:prepend>
              <v-icon>mdi-facebook</v-icon>
            </template>
            Mit Facebook anmelden
          </v-btn>
        </v-col>
      </v-row>
  <v-row class="my-4">
    <v-col cols="12" md="12">
      <div class="divider-container">
      <v-divider></v-divider>
      <span class="divider-text"><b>{{ t('loginView.divider') }}</b></span>
      <v-divider></v-divider>
    </div>
    </v-col>
  </v-row>
  </span>
          <div class="token-login-card">
            <div class="card-header">
              <h3 class="token-login-title">{{ t('loginView.form.signIn') }}</h3>
              <p class="token-login-text">
                {{ t('loginView.subtitle') }}
              </p>
            </div>
            <v-form ref="form" @submit.prevent="startLogin" class="card-form">
 
            <v-text-field
              v-model="userLogin.user_name"
              :error-messages="emailError"
              @blur="validateUserName"
              @input="validateForm"
              :label="t('loginView.form.usernameLabel')"
              type="text"
              required
            ></v-text-field>
    
            <v-text-field
              v-model="userLogin.user_password"
              :label="t('loginView.form.passwordLabel')"
              :type="showPassword ? 'text' : 'password'"
              append-icon="mdi-eye"
              @click:append="toggleShowPassword"
              @input="validateForm"
              required
            ></v-text-field>
          
            <v-row v-if="showFormError">
             
              <v-col cols="12" class="my-2" >
                <ul class="ml-8">
                  <li v-for="error in formErrors" :key="error">
                    <span v-if="error" class="error">{{ error }}</span>
                  </li>
                </ul>
              </v-col>
            </v-row>
          
            <v-btn 
              type="submit" 
              color="#EA5545"
              class="clearment-btn-primary"
              block
            >{{ t('loginView.form.signIn') }}</v-btn>
            
            <v-btn
              class="mt-3 clearment-btn-text"
              @click="showPassVergessen = !showPassVergessen"
              variant="text"
              block
            >{{ t('loginView.form.forgotPassword') }}</v-btn>
            </v-form>
          </div>
        </div>
        <div v-if="showPassVergessen">
          <h2 class="mb-4 clearment-title">{{ t('loginView.form.resetTitle') }}</h2>
          <p class="clearment-subtitle mb-4">{{ t('loginView.form.resetSubtitle') }}</p>
          
          <v-form ref="form" @submit.prevent="startPasswortVergessen">
            <v-text-field
              v-model="userLogin.user_name"
              :error-messages="emailError"
              @blur="validateUserName"
              @input="validateFormVergessen"
              :label="t('loginView.form.usernameLabel')"
              type="text"
              required
              class="mb-4"
            ></v-text-field>

            <span v-if="formErrors.email" class="error">{{ formErrors.email }}</span>

            <v-btn 
              type="submit" 
              color="#EA5545"
              class="clearment-btn-primary"
              block
            >{{ t('loginView.form.sendReset') }}</v-btn>

            <v-btn
              class="mt-3 clearment-btn-text"
              variant="text"
              @click="showPassVergessen = !showPassVergessen"
              block
            >{{ t('loginView.form.backToSignIn') }}</v-btn>
            <v-row v-if="showFormErrorVergessen">
             
             <v-col cols="12" class="my-2" >
               <ul class="ml-8">
                <li v-for="error in formErrors" :key="error">
                  <span v-if="error" class="error">{{ error }}</span>
                </li>
              </ul>
            </v-col>
          </v-row>
        


          </v-form>
        </div>
      </span>
  </div>
</template>

<script setup>
import {  ref, inject, watch,defineProps,onMounted } from "vue";
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/userStore';
import { useRouter } from 'vue-router';
import { useLanguage } from '@/composables/useLanguage'
const router = useRouter();
const baseCalls = inject('baseCalls')
const loaderStore = inject('loaderStore')
const errorStore = inject('errorStore')
const successStore = inject('successStore');
const userStore = useUserStore();
const { t } = useLanguage()
const showClose = ref(false);
const isLoggedIn = ref(false);
const showPassVergessen = ref(false);
const showSocialLogin = ref(false);
const showFacebookLogin = ref(true);
const userLogin = ref({
  user_name: '',
  user_password: '',
  action: 'startlogin',
});
const tokenLogin = ref({
  token: ''
})
const tokenLoginErrors = ref({
  token: ''
})
const tokenFormSubmitted = ref(false)
const { userData } = storeToRefs(userStore)
const showPassword = ref(false);
const emailError = ref('');
const form = ref(null);
const submitStarted = ref(false);

const props = defineProps({
     newRoute: {
       type: [String]
     }
   });
const brandName = 'Clearment'
console.log(props.newRoute);
// Watcher für den Benutzernamen
watch(() => userLogin.value.user_name, (newName) => {
  // Überprüfe, ob der Benutzername gültig ist, während der Benutzer tippt
  if (newName && newName.length >= 3) {
    // Wenn der Benutzername gültig ist, setze den Fehler zurück
    emailError.value = '';
  }
});


async function countSocialLogins(what) {
  // Formular validieren
  let data = {
    what: what,
    action: 'countSocialLogins'
  }
  baseCalls.userPost(data);

  // Prüfen, ob es Fehler gibt
  
}

const toggleShowPassword = () => {
  showPassword.value = !showPassword.value;
};

function validateUserName() {
  if (!userLogin.value.user_name || userLogin.value.user_name.length < 3) {
    emailError.value = t('loginView.errors.usernameShort');
    return false;
  }
  emailError.value = '';
  return true;
}


const showFormError = ref(false)
const showFormErrorVergessen = ref(false)
// Fehlerobjekt
const formErrors = ref([])

function validateFormVergessen() {
  // Validierung der Eingabefelder
  formErrors.value = [];
  
  if (!userLogin.value.user_name || userLogin.value.user_name.length < 3) {
    formErrors.value.push(t('loginView.errors.usernameShort'));
  }

 if (formErrors.value.length > 0 && submitStarted.value) {
    showFormErrorVergessen.value = true;
  } else {
    showFormErrorVergessen.value = false;
    submitStarted.value = false;
  }
 
}
// Validierungsfunktion
function validateForm() {
  // Validierung der Eingabefelder
  formErrors.value = [];
  
  if (!userLogin.value.user_name || userLogin.value.user_name.length < 3) {
    formErrors.value.push(t('loginView.errors.usernameShort'));
  } 
  if (userLogin.value.user_password.length < 6) {
    formErrors.value.push(t('loginView.errors.passwordShort'));
  }
 if (formErrors.value.length > 0 && submitStarted.value) {
    showFormError.value = true;
  } else {
    showFormError.value = false;
    submitStarted.value = false;
  }
 
}

// Funktion, die prüft, ob es Fehler gibt
function hasErrors() {
 
  showFormError.value = Object.values(formErrors.value).some(error => error !== '')
  return Object.values(formErrors.value).some(error => error !== '')
  
}

// Login-Funktion
async function startLogin() {
  // Formular validieren
  submitStarted.value = true;
  validateForm()

  // Prüfen, ob es Fehler gibt
  if (hasErrors()) {
    console.log('Fehler im Formular, Login nicht möglich')
    return
  }

  // Wenn keine Fehler vorhanden sind, Login-Logik ausführen
  console.log('Login wird gestartet...')
  // Ladezustand aktivieren
  loaderStore.setLoader(true, "Bitte warten, Sie werden eingeloggt...");

  try {
    const response = await baseCalls.userPost(userLogin.value);
    if (response.data.user ) {
      console.log('Benutzerdaten geladen:', response.data);
      userStore.setUser(response.data.user )
      loaderStore.setLoader(false);
      if (props.newRoute) {
            // Timeout von 1 Sekunde vor der Weiterleitung
          router.push(props.newRoute);
      }
    } else {
      errorStore.setError(true, 'Ihre Zugangsdaten sind scheinbar nicht korrekt');
    }
  } catch (err) {
   
    errorStore.setError(true, 'Ihre Zugangsdaten sind scheinbar nicht korrekt');
    console.error('API-Fehler:', err);
  } finally {

    loaderStore.setLoader(false);
  }
}


async function startPasswortVergessen() {

  submitStarted.value = true;
  validateFormVergessen()
    if (hasErrors()) {
      console.log('Fehler im Formular, Login nicht möglich')
      return
    }
  loaderStore.setLoader(true, "Bitte warten, Passwort wird zugesendet...");
  userLogin.value.action = 'passwortvergessen';
  try {
    const response = await baseCalls.userPost(userLogin.value);
    if (response.data.success ) {
      console.log('Passwort wurde zugesendet:', response.data);
      userLogin.value.user_name = '';
      userLogin.value.action = 'startlogin';
      loaderStore.setLoader(false);
      successStore.setSuccess(true, 'Passwort wurde zugesendet', 'Bitte überprüfen Sie Ihre E-Mail');
      userStore.setLoginView(false)
    
    } else {
      errorStore.setError(true, 'Ihr Benutzername ist scheinbar nicht korrekt');
    }
  } catch (err) {
  
    errorStore.setError(true, 'Ihr Benutzername ist scheinbar nicht korrekt');
    console.error('API-Fehler:', err);
  } finally {

    loaderStore.setLoader(false);
  }
}
async function startLoginFacebook(payload) {
  // Formular validieren
  submitStarted.value = true;

  // Prüfen, ob es Fehler gibt
  let data = {
    user_email: payload.email,
    user_facebook_id: payload.id,
    user_name: payload.name,
    action: 'startLoginFacebook'
  }

  // Wenn keine Fehler vorhanden sind, Login-Logik ausführen
  console.log('Login wird gestartet...')
  // Ladezustand aktivieren
  loaderStore.setLoader(true, "Bitte warten, Sie werden eingeloggt...");

  try {
    const response = await baseCalls.userPost(data);
    if (response.data.user ) {
      console.log('Benutzerdaten geladen:', response.data);
      isLoggedIn.value = true;
      userStore.setUser(response.data.user )
      loaderStore.setLoader(false);
      if (props.newRoute) {
          // Timeout von 1 Sekunde vor der Weiterleitung
          router.push(props.newRoute);
      }
    } else {
      errorStore.setError(true, response.data.message);
    }
  } catch (err) {
   
    errorStore.setError(true, 'Es ist ein Fehler aufgetreten');
    console.error('API-Fehler:', err);
  } finally {

    loaderStore.setLoader(false);
  }
}

function validateTokenLogin() {
  const errors = {
    token: ''
  }
  if (!tokenLogin.value.token || tokenLogin.value.token.length < 6) {
    errors.token = t('loginView.errors.tokenMissing')
  }
  tokenLoginErrors.value = errors
  return !errors.token
}

async function startTokenLoginFromForm() {
  tokenFormSubmitted.value = true
  if (!validateTokenLogin()) {
    return
  }
  loaderStore.setLoader(true, t('app.messages.tokenLoginLoading'))
  try {
    const response = await baseCalls.userPost({
      action: 'startlogin',
      token: tokenLogin.value.token
    })
    if (response.data.user) {
      userStore.setUser(response.data.user)
      successStore.setSuccess(
        true,
        t('app.messages.loginSuccessTitle'),
        t('app.messages.loginSuccessBody')
      )
      userStore.setLoginView(false)
      if (props.newRoute) {
        router.push(props.newRoute)
      }
    } else {
      errorStore.setError(true, t('app.messages.invalidToken'))
    }
  } catch (err) {
    console.error('Token login error:', err)
    errorStore.setError(true, t('app.messages.tokenLoginError'))
  } finally {
    loaderStore.setLoader(false)
  }
}

watch(
  () => tokenLogin.value.token,
  () => {
    if (tokenFormSubmitted.value) {
      validateTokenLogin()
    }
  }
)

function loginWithGoogle() {
  countSocialLogins('google');
  errorStore.setError(true, 'Google-Login ist derzeit deaktiviert.');
}

function loginWithFacebook() {
  countSocialLogins('facebook');
  /* global FB */
  FB.login(function(response) {
    if (response.authResponse) {
      // Hier wird der Access Token aus der Antwort verwendet, 
      // ohne ihn global zu setzen
      const accessToken = response.authResponse.accessToken;
      
      FB.api('/me', { access_token: accessToken, fields: 'name,email' }, function(userData) {
        if(userData.id){
         
          console.log('Good to see you, ' + userData.name + '.');
          console.log(userData);
          startLoginFacebook(userData);
        }
       
        // Hier kannst du mit dem Benutzer und seinem Token arbeiten
      });
    } else {
      console.log('User cancelled login or did not fully authorize.');
    }
  }, { scope: 'public_profile,email' });
}

onMounted(() => {
  // Facebook SDK initialisieren
  window.fbAsyncInit = function() {
    FB.init({
      appId: '563907036335909',
      cookie: true,
      xfbml: true,
      version: 'v12.0'
    });
  };

  // Facebook SDK laden
  (function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
});

</script>

<style scoped src="@/assets/styles/sfc/components/objects/user/LoginView.css"></style>
